export interface DriverAnnotationOptions {
  title?: string
  anchorOffset?: DOMPoint
  rotation?: number
}

const factory = (coordinate, options: DriverAnnotationOptions = {}) => {
  const div = document.createElement('div')
  div.className = 'driver-marker'
  div.style.width = '38px'
  div.style.height = '47px'
  div.style.backgroundImage = `url('/images/driver_2x.png')`
  div.style.backgroundSize = '38px 47px'
  div.style.objectFit = 'contain'
  div.style.transform = `rotate(${options.rotation || 0}deg)`
  div.style.transition = 'transform 250ms ease-in-out'
  return div
}

export default function buildDriverAnnotation(
  mapkit,
  coordinate,
  options: DriverAnnotationOptions
) {
  return new mapkit.Annotation(coordinate, factory, {
    ...options,
    anchorOffset: new DOMPoint(-5, -20),
    size: {
      width: 38,
      height: 47
    }
  })
}
